import { h } from 'preact';
export const Calendar = (props) => {
    const color = props.color || 'currentColor';
    const size = props.size || 24;
    delete props.color;
    delete props.size;
    return (h("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: size, height: size, viewBox: "0 0 24 24", fill: "none", stroke: color, "stroke-width": "2", "stroke-linecap": "round", "stroke-linejoin": "round" }, props),
        h("rect", { x: "3", y: "4", width: "18", height: "18", rx: "2", ry: "2" }),
        h("line", { x1: "16", y1: "2", x2: "16", y2: "6" }),
        h("line", { x1: "8", y1: "2", x2: "8", y2: "6" }),
        h("line", { x1: "3", y1: "10", x2: "21", y2: "10" })));
};
//# sourceMappingURL=calendar.js.map